import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import * as api from "../api";

function MotDePasseOublie() {
  const [step, setStep]                       = useState(1);
  const [email, setEmail]                     = useState("");
  const [otp, setOtp]                         = useState("");
  const [newPassword, setNewPassword]         = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPwd, setShowPwd]                 = useState(false);
  const [error, setError]                     = useState("");
  const [loading, setLoading]                 = useState(false);
  const navigate                              = useNavigate();

  const inputStyle = {
    width: "100%", padding: "12px 15px", border: "1.5px solid #e5e7eb",
    borderRadius: "8px", fontSize: "14px", outline: "none",
    boxSizing: "border-box", transition: "border-color 0.2s", fontFamily: "inherit"
  };

  const handleRequestOTP = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.requestPasswordReset({ email: email.toLowerCase().trim() });
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.message || "Email introuvable.");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword.length < 6) { setError("Le mot de passe doit contenir au moins 6 caractères."); return; }
    if (newPassword !== confirmPassword) { setError("Les mots de passe ne correspondent pas."); return; }
    if (!otp || otp.length !== 6) { setError("Veuillez entrer le code à 6 chiffres reçu par email."); return; }
    setLoading(true);
    try {
      await api.confirmPasswordReset({ email: email.toLowerCase().trim(), otp, newPassword });
      setStep(3);
    } catch (err) {
      setError(err.response?.data?.message || "Code incorrect ou expiré.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f9fafb", padding: "60px 20px" }}>
        <div style={{ width: "100%", maxWidth: "440px" }}>
          <div style={{ backgroundColor: "white", padding: "40px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>

            {step === 3 && (
              <div style={{ textAlign: "center" }}>
                <div style={{ width: "72px", height: "72px", borderRadius: "50%", backgroundColor: "#f0fdf4", border: "3px solid #86efac", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px" }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg>
                </div>
                <h2 style={{ fontSize: "22px", fontWeight: "700", color: "#1f2937", marginBottom: "12px" }}>Mot de passe modifié !</h2>
                <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "28px", lineHeight: "1.6" }}>
                  Votre mot de passe a bien été mis à jour. Vous pouvez maintenant vous connecter.
                </p>
                <button onClick={() => navigate("/connexion")} style={{ width: "100%", padding: "13px", backgroundColor: "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "15px", fontWeight: "600", cursor: "pointer" }}>
                  Se connecter
                </button>
              </div>
            )}

            {step !== 3 && (
              <>
                <div style={{ textAlign: "center", marginBottom: "28px" }}>
                  <div style={{ width: "60px", height: "60px", borderRadius: "50%", backgroundColor: "#f0fdfa", border: "2px solid #0d9488", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
                    </svg>
                  </div>
                  <h1 style={{ fontSize: "22px", fontWeight: "700", color: "#1f2937", marginBottom: "6px" }}>Mot de passe oublié</h1>
                  <p style={{ color: "#6b7280", fontSize: "14px" }}>
                    {step === 1
                      ? "Entrez votre email pour recevoir un code de vérification"
                      : `Entrez le code reçu à ${email} et choisissez un nouveau mot de passe`}
                  </p>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "24px" }}>
                  {[1, 2].map(s => (
                    <React.Fragment key={s}>
                      <div style={{ width: "28px", height: "28px", borderRadius: "50%", backgroundColor: step >= s ? "#0d9488" : "#e5e7eb", color: step >= s ? "white" : "#9ca3af", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "700", flexShrink: 0 }}>{s}</div>
                      {s < 2 && <div style={{ flex: 1, height: "2px", backgroundColor: step > s ? "#0d9488" : "#e5e7eb" }}/>}
                    </React.Fragment>
                  ))}
                </div>

                {error && (
                  <div style={{ backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", padding: "12px 15px", marginBottom: "20px", color: "#dc2626", fontSize: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    {error}
                  </div>
                )}

                {step === 1 && (
                  <form onSubmit={handleRequestOTP}>
                    <div style={{ marginBottom: "20px" }}>
                      <label style={{ display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" }}>Adresse email</label>
                      <input type="email" value={email} onChange={e => { setEmail(e.target.value); setError(""); }}
                        placeholder="votre@email.com" required style={inputStyle}
                        onFocus={e => e.target.style.borderColor = "#0d9488"}
                        onBlur={e => e.target.style.borderColor = "#e5e7eb"}
                      />
                    </div>
                    <button type="submit" disabled={loading} style={{ width: "100%", padding: "13px", backgroundColor: loading ? "#9ca3af" : "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "15px", fontWeight: "600", cursor: loading ? "not-allowed" : "pointer", marginBottom: "16px", fontFamily: "inherit" }}>
                      {loading ? "Envoi en cours..." : "Envoyer le code"}
                    </button>
                  </form>
                )}

                {step === 2 && (
                  <form onSubmit={handleReset}>
                    <div style={{ background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: "8px", padding: "12px 15px", marginBottom: "20px", fontSize: "13px", color: "#0f766e" }}>
                      📧 Un code à 6 chiffres a été envoyé à <strong>{email}</strong>. Vérifiez aussi vos spams.
                    </div>

                    <div style={{ marginBottom: "18px" }}>
                      <label style={{ display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" }}>Code de vérification</label>
                      <input type="text" value={otp}
                        onChange={e => { setOtp(e.target.value.replace(/\D/g, "").slice(0, 6)); setError(""); }}
                        placeholder="123456" maxLength={6} required
                        style={{ ...inputStyle, letterSpacing: "6px", fontSize: "20px", textAlign: "center", fontWeight: "700" }}
                        onFocus={e => e.target.style.borderColor = "#0d9488"}
                        onBlur={e => e.target.style.borderColor = "#e5e7eb"}
                      />
                    </div>

                    <div style={{ marginBottom: "18px" }}>
                      <label style={{ display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" }}>Nouveau mot de passe</label>
                      <div style={{ position: "relative" }}>
                        <input type={showPwd ? "text" : "password"} value={newPassword}
                          onChange={e => { setNewPassword(e.target.value); setError(""); }}
                          placeholder="Minimum 6 caractères" required
                          style={{ ...inputStyle, paddingRight: "44px" }}
                          onFocus={e => e.target.style.borderColor = "#0d9488"}
                          onBlur={e => e.target.style.borderColor = "#e5e7eb"}
                        />
                        <button type="button" onClick={() => setShowPwd(v => !v)}
                          style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#9ca3af" }}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            {showPwd
                              ? <><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></>
                              : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>}
                          </svg>
                        </button>
                      </div>
                      {newPassword.length > 0 && (
                        <div style={{ marginTop: "8px" }}>
                          <div style={{ display: "flex", gap: "4px", marginBottom: "4px" }}>
                            {[1,2,3,4].map(i => {
                              const strength = newPassword.length < 6 ? 1 : newPassword.length < 8 ? 2 : /[A-Z]/.test(newPassword) && /[0-9]/.test(newPassword) ? 4 : 3;
                              return <div key={i} style={{ flex: 1, height: "3px", borderRadius: "2px", backgroundColor: i <= strength ? (strength <= 1 ? "#ef4444" : strength <= 2 ? "#f59e0b" : strength <= 3 ? "#3b82f6" : "#10b981") : "#e5e7eb" }}/>;
                            })}
                          </div>
                          <span style={{ fontSize: "11px", color: newPassword.length < 6 ? "#ef4444" : newPassword.length < 8 ? "#f59e0b" : "#10b981" }}>
                            {newPassword.length < 6 ? "Trop court" : newPassword.length < 8 ? "Moyen" : /[A-Z]/.test(newPassword) && /[0-9]/.test(newPassword) ? "Très fort" : "Fort"}
                          </span>
                        </div>
                      )}
                    </div>

                    <div style={{ marginBottom: "20px" }}>
                      <label style={{ display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" }}>Confirmer le mot de passe</label>
                      <input type={showPwd ? "text" : "password"} value={confirmPassword}
                        onChange={e => { setConfirmPassword(e.target.value); setError(""); }}
                        placeholder="Retapez le mot de passe" required
                        style={{ ...inputStyle, borderColor: confirmPassword && confirmPassword !== newPassword ? "#ef4444" : undefined }}
                        onFocus={e => e.target.style.borderColor = "#0d9488"}
                        onBlur={e => e.target.style.borderColor = confirmPassword && confirmPassword !== newPassword ? "#ef4444" : "#e5e7eb"}
                      />
                      {confirmPassword && confirmPassword !== newPassword && (
                        <p style={{ fontSize: "12px", color: "#ef4444", marginTop: "4px" }}>Les mots de passe ne correspondent pas</p>
                      )}
                    </div>

                    <div style={{ display: "flex", gap: "10px" }}>
                      <button type="button" onClick={() => { setStep(1); setOtp(""); setError(""); }}
                        style={{ flex: 1, padding: "13px", backgroundColor: "white", color: "#374151", border: "1.5px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", fontWeight: "600", cursor: "pointer", fontFamily: "inherit" }}>
                        Retour
                      </button>
                      <button type="submit" disabled={loading}
                        style={{ flex: 2, padding: "13px", backgroundColor: loading ? "#9ca3af" : "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: "600", cursor: loading ? "not-allowed" : "pointer", fontFamily: "inherit" }}>
                        {loading ? "Vérification..." : "Modifier le mot de passe"}
                      </button>
                    </div>
                  </form>
                )}

                <p style={{ textAlign: "center", marginTop: "20px", fontSize: "14px", color: "#6b7280" }}>
                  <Link to="/connexion" style={{ color: "#0d9488", textDecoration: "none", fontWeight: "600" }}>← Retour à la connexion</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MotDePasseOublie;